import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { ENV_FILE_TOKEN } from "gast-common-ng2";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";

/**
 * Performs a redirect to hkv auth service to re login in case of the error response with code: {@link HttpStatusCode#Unauthorized}
 *
 * @author Mateusz Warzyc
 * @param req request
 * @param next request handler
 */
export const hkvPortalAuthErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const envConfig = inject(ENV_FILE_TOKEN);
  const loginUrl = `${envConfig.portalAuthServiceUrl}?redirect=${document.location.href}`;

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      if (HttpStatusCode.Unauthorized === response.status) {
        window.location.href = loginUrl;
      }
      return throwError(() => req);
    })
  );
};
